import { IStoreState } from "@/types/StoreTypes";
import { UpdateConfig } from "..";

export function createSupportSlice(params: {
  localStorageState: IStoreState;
  setAndProduce: (
    fn: (state: IStoreState, config?: UpdateConfig) => void,
    config?: UpdateConfig,
  ) => void;
}) {
  const { setAndProduce } = params;

  return {
    activeSupportVideoId: null,
    setActiveSupportVideoId: (videoId: string | null) =>
      setAndProduce((state) => {
        state.support.activeSupportVideoId = videoId;
      }),
  };
}
